export const loginMessages = {
  userName: 'Tên đăng nhập',
  password: 'Mật khẩu',
  email: 'Email',
  isADAccount: 'Tài khoản AD',
  forgotPassword: 'Quên mật khẩu',
  loginButtonText: 'Đăng nhập',
  continueButtonText: 'Tiếp tục',
  forgotSubText: 'Vui lòng nhập email được liên kết với tài khoản để nhận mã xác thực.',
  inputOtp: 'Nhập mã xác thực',
  inputOtpSubText: 'Mã xác thực 6 chữ số đã được gửi qua email',
  resetPassword: 'Tạo mật khẩu mới',
  showPassword: 'Hiện mật khẩu',
  hidePassword: 'Ẩn mật khẩu',
  ipAddress: 'Địa chỉ ip',
  backToLogin: 'Quay lại màn hình đăng nhập',
};
